import axios from '../../http'
import { handleGetRequestParams } from '../../common/js/util'

class DBMarketing {
  // DB添加广告弹窗
  postDBAddAd(adUrl, adPath, isUsed) {
    let url = `/api/db/ad/add`
    let data = {
      adUrl,
      adPath,
      isUsed
    }
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // DB获取当前广告弹窗
  getDBAd() {
    let url = `/api/db/ad/info`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // DB获取商品推荐列表
  getDBRecommend() {
    let url = `/api/goods/recommend/list`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // DB获取添加商品推荐
  postDBAddRecommend(data) {
    let url = `/api/goods/recommend/add`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // DB获取套餐列表
  getDBPackage(currentPage) {
    let url = `/api/db/set/meal/list?currentPage=${currentPage}`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // DB添加套餐
  postDBAddPackage(data) {
    let url = `/api/db/set/meal/add`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // DB删除套餐
  postDBDeletePackage(data) {
    let url = `/api/db/set/meal/del`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // DB上架/下架套餐
  postDBStatusPackage(data) {
    let url = `/api/db/set/meal/update/status`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // DB套餐详情
  getDBDetailPackage(id) {
    let url = `/api/db/set/meal/detail?id=${id}`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // DB套餐更新
  getDBUpdatePackage(data) {
    let url = `/api/db/set/meal/update`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // DB获取促销列表
  getDBPromotionList(options) {
    let url = `/api/db/promotion/list?`
    url += handleGetRequestParams(options)
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // DB更新促销状态
  postDBUpdatePromotionStatus(data) {
    let url = `/api/db/promotion/update/status`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // DB删除促销商品
  postDBDeletePromotionGoods(data) {
    let url = `/api/db/promotion/del`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // DB新增促销
  postDBAddPromotionGoods(data) {
    let url = `/api/db/promotion/add`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // DB获取促销详情
  getDBPromotionDetail(id) {
    let url = `/api/db/promotion/detail?id=${id}`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // DB更改促销
  postDBUpdatePromotionGoods(data) {
    let url = `/api/db/promotion/update`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 是否开启折上折
  getDBUpdatePromotionDiscount(status) {
    let url = `/api/db/promotion/discount?status=${status}`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 获取折上折状态
  getDBPromotionDiscountStatus() {
    let url = `/api/db/promotion/discount/get`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
}

export default DBMarketing
